// extracted by mini-css-extract-plugin
module.exports = {"Alarm__wrapper":"Alarm_Alarm__wrapper__3e-2_","Alarm__rowWrapper":"Alarm_Alarm__rowWrapper__2OiAg"};